/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

export default function HiddenWidget({ id, value }) {
  return <input aria-hidden={true} type="hidden" id={id} value={!value ? '' : value} />;
}
